import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Map } from 'immutable';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { SubHeading } from '../styles/SubHeading';
import { ProductCardTitle, ProductCardLink, ProductCardContainer, ProductTagContainer } from './ProductCard';
import { ProductTag } from '../styles/ProductTag';
import RenderPrice from './RenderPrice';
import { Conditional } from './Conditional';

const StoreItemCard = props => {
  const { url, productName, image, tag, price, originalPrice } = props;
  let { brand } = props;
  if (brand === null) {
    brand = Map();
  }
  const imageProps = '?width=600&heightRatio=0.93&mode=crop';

  if (!url || !productName || !image.get('url') || !price) return false;

  return (
    <ProductCardLink to={url}>
      <ProductCardContainer>
        <ImageContainer>
          <Conditional show={!tag.isEmpty()}>
            <ProductTagContainer>
              <ProductTag color={tag.get('key')}>{tag.get('value')}</ProductTag>
            </ProductTagContainer>
          </Conditional>
          <Conditional show={!!image.get('url')}>
            <Image src={SITE_ROOT_URL + image.get('url') + imageProps} alt={image.get('alt')} />
          </Conditional>
        </ImageContainer>

        <ContentContainer>
          <Conditional show={!!brand.get('name')}>
            <SubHeading uppercase title={brand.get('name')}>
              {brand.get('name')}
            </SubHeading>
          </Conditional>
          <ProductCardTitle title={productName}>{productName}</ProductCardTitle>
          <RenderPrice small fontWeight="600" price={price} originalPrice={originalPrice} />
        </ContentContainer>
      </ProductCardContainer>
    </ProductCardLink>
  );
};

StoreItemCard.defaultProps = {
  brand: Map(),
  tag: Map(),
  originalPrice: null
};

StoreItemCard.propTypes = {
  url: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  image: PropTypes.instanceOf(Map).isRequired,
  price: PropTypes.number.isRequired,
  originalPrice: PropTypes.number,
  tag: PropTypes.instanceOf(Map),
  brand: PropTypes.instanceOf(Map)
};

export default StoreItemCard;

const ImageContainer = styled.div`
  width: 100%;
  height: 0;
  padding-bottom: 93%;
  position: relative;
  overflow: hidden;
`;

const Image = styled.img`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  object-fit: cover;
  width: 100%;
`;

const ContentContainer = styled.div`
  padding-top: 20px;
  width: 100%;
  height: auto;
  text-align: center;
  background-color: white;
`;



// WEBPACK FOOTER //
// ./src/components/StoreItemCard.js